module.exports = __webpack_public_path__ + "static/media/VestasSans-Light.f5e08775.eot";